import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { retrieveMetrics } from '../utils/retrieveMetrics'
import { AnnotatedMediaMetricResult } from '../../types'

const PopularMediaNoDataGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<AnnotatedMediaMetricResult>(widgetId)
  const { t } = useTranslation()
  const metrics = retrieveMetrics(widgetData.data[0])

  if (metrics.length === 0) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }
  return children
}

export default PopularMediaNoDataGuard
